import { ref } from "vue";

export function useModel<T extends object>(ModelClass: new () => T) {
  const modelClass = ref<T>(new ModelClass());

  const clearModel = () => (modelClass.value = new ModelClass());

  const setModel = (data: Partial<T>) => (modelClass.value = new ModelClass(data));

  return { modelClass, clearModel, setModel };
}
